import React, { useEffect } from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import { SvgIcon } from '@mui/material';
import { Check as CheckIcon } from '@mui/icons-material';
import PropTypes from 'prop-types';
import { parse, format } from 'date-fns';
import AppointmentProductDetail from '../QuoterComponents/AppointmentProductDetail';
import PhoneCallIcon from '../../../../icons/phoneCall.svg?react';
import InsurancePlanFooter from '../../Common/InsurancePlanFooter/InsurancePlanFooter';
import { InsurancePlan } from '../Helpers/Constant';
import { SESSION_STORAGE_CUSTOMIZED_HEALTH_KEY, SESSION_STORAGE_CUSTOMIZED_TERM_KEY } from '../../../../sessionStorage';
import CustomerSupportPhone from "../../../Account/CustomerSupportPhone";
import { CustomNextSteps } from '../../../Quoters/Common/Appointment/CustomNextSteps';
import './SelectAppointment.scss';
import './ScheduleAppointment.scss';

export default function ScheduleAppointment(props) {

  useEffect(() => {
    sessionStorage.removeItem(SESSION_STORAGE_CUSTOMIZED_HEALTH_KEY);
    sessionStorage.removeItem(SESSION_STORAGE_CUSTOMIZED_TERM_KEY);
  }, []);

  const customerSupportPhone = CustomerSupportPhone();
  const appointment = props.appointment;

  let contactDatetime = 'within one business day';

  if (appointment.specificAppt === 'schedule') {
    if (appointment.specificApptTime && appointment.specificApptDate && appointment.timeZone) {
      const contactDate = parse(appointment.specificApptDate, 'MM-dd-yyyy', new Date());
      contactDatetime = `${format(contactDate, 'EEEE, MMMM d')} ${appointment.specificApptTime} ${appointment.timeZone}`;
    } else {
      contactDatetime = 'at your specified date and time';
    }
  }

  return (
    <React.Fragment>
      <Container className='custom-appointment-info py-4'>
        <Row>
          <Col md={6} className="review-container d-flex align-items-center w-100">
            <div className="coverage-detail-container">
              <AppointmentProductDetail quote={props.quoter}/>
            </div>
            <CustomNextSteps title={props.title} data={props.data} />
          </Col>
          <Col md={6} lg={4} className="mx-auto">
            <React.Fragment>
              <div className='fixed-schedule text-center'>
                <Row className="justify-content-center">
                  <SvgIcon component={CheckIcon} className="icons" color="primary" fontSize="large"/>
                </Row>
                <div className="schedule-title mb-1 mt-2">
                  <h4>Congrats - your call has been scheduled</h4>
                </div>
                <div className='content-title'>
                  <div className='schedule-content' ><b>We will contact you {appointment.specificAppt === 'schedule' ? 'on ' : '' }<span
                    className="colorText">{contactDatetime}</span> within a 30 minute timeframe of your appointment</b></div>
                </div>
                <div className='text-start team-content'>
                  Your licensed expert will review all of your options and tailor a solution that meets your needs and budget. This call is a required step to legally ensure your “best interests” and takes less than 15 minutes. We’ll make the whole process simple and easy, and look forward to speaking with you!
                </div>
                <div className='mt-4'><b>Want to talk to someone today?</b></div>
                <Row className='mt-2 d-flex justify-content-center'>
                  <SvgIcon component={PhoneCallIcon} color="primary" className='me-1 px-0'/>
                  <b className='px-0'><a href={`tel:${customerSupportPhone}`} className={`colorText ms-1`}>{customerSupportPhone}</a></b>
                </Row>
              </div>
              <div/>
            </React.Fragment>
          </Col>
        </Row>
      </Container>
     <InsurancePlanFooter InsurancePlan={InsurancePlan} props={props}/>
    </React.Fragment>
  );
}

ScheduleAppointment.propTypes = {
  appointment: PropTypes.object,
  title: PropTypes.string,
  quoter: PropTypes.object,
  data: PropTypes.array,
};
